import React from 'react';
import '../styles/ZwykDescription.css';
import ZwykUseCase from './ZwykUseCase';
import womanCamping from '../assets/woman-camping.avif';
import mountHikers from '../assets/mount-hikers.avif';
import summerMountainTrekking from '../assets/summer-mountain-trekking.jpg';

const ZwykDescription: React.FC = () => {
  return (
    <div className="zwyk-description">
      <div className="zwyk-description-container">
        <h1 className='zwyk-description-title '>
          Dla kogo jest ZWYK?
        </h1>
        <div className="zwyk-description-content">
          <b>Zwyk</b> – w gwarze górali żywieckich to spotkanie w górach, zwykle pasterzy lub sąsiadów, służące rozmowie, wspólnej pracy lub świętowaniu. Dawniej „zwykowanie" było istotną częścią życia społecznego w Beskidach.
        </div>
      </div>
      <div className='use-cases-container'>
        <ZwykUseCase 
          imageUrl={womanCamping}
          imgHeader="Dla miłośników gór" 
          description="Dla wszystkich, którzy chcą podróżować wspólnie z innym!"
        />
        <ZwykUseCase 
          imageUrl={mountHikers}
          imgHeader="Dla organizacji turystycznych"
          description="Dla organizacji związanymi z turystyką górską, takich jak kluby/koła PTT, czy też kluby wysokogórskie."
        />  
        <ZwykUseCase 
          imageUrl={summerMountainTrekking}
          imgHeader="Dla przewodników"
          description="Dla przewodników, którzy chcą dotrzeć do nowych klientów."
        />
      </div>
    </div>
  );
};

export default ZwykDescription;